export default {
      id: "live-filter-white-usage",
      viewBox: "0 0 22 21",
      url: "/" + "images/icons.3.109.2.svg#live-filter-white-usage",
      toString: function () {
        return this.url;
      }
    }